import { createContext } from 'react';

// Quimby Table hands a cell renderer only { item, dataKey, index }, so anything
// row-independent — whether the user may edit, and how to open the drawer — has
// to arrive out of band.
const TagsGridContext = createContext({
  canEdit: false,
  onOpenTag: () => {}
});

export default TagsGridContext;
